export default __webpack_public_path__ + "static/tirumarai-selvan-292c97c95657945b34d2eeb43b2d4921.png";